import { ElementRef, inject } from "@angular/core";

export namespace AngBridgeUtil {
    // bridge to AngularJS; used for AngJS to set model values and call setter fns
    export function init(component: object) {
        inject(ElementRef).nativeElement.angBridge = component;
    }
}
